export default __webpack_public_path__ + "static/media/svs.d77e718c.jpg";